/* BROEK — carousel dots: dot pagination for the style-edit strips, autoplay for the Judge.me cards carousel. */
(function () {
  'use strict';
  if (typeof document === 'undefined' || window.__broekCarouselDots) return;
  window.__broekCarouselDots = true;

  var raf = window.requestAnimationFrame || function (fn) { return setTimeout(fn, 16); };
  var wired = [];
  var refreshers = [];

  function buildNav(pages, onSelect) {
    var nav = document.createElement('div');
    nav.className = 'broek-carousel-dots';
    for (var i = 0; i < pages; i++) {
      var button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      button.setAttribute('data-index', String(i));
      button.addEventListener('click', function () { onSelect(Number(this.getAttribute('data-index'))); });
      nav.appendChild(button);
    }
    return nav;
  }

  function ownNav(root) {
    for (var i = 0; i < root.children.length; i++) {
      if (root.children[i].classList && root.children[i].classList.contains('broek-carousel-dots')) return root.children[i];
    }
    return null;
  }

  function ensureNav(root, pages, onSelect) {
    var nav = ownNav(root);
    if (nav && nav.children.length === pages) return nav;
    if (nav) nav.parentNode.removeChild(nav);
    nav = buildNav(pages, onSelect);
    root.appendChild(nav);
    return nav;
  }

  function dropNav(root) {
    var nav = ownNav(root);
    if (nav) nav.parentNode.removeChild(nav);
    root.classList.remove('broek-has-dots');
  }

  function mark(nav, index) {
    if (!nav) return;
    for (var i = 0; i < nav.children.length; i++) {
      nav.children[i].setAttribute('aria-current', i === index ? 'true' : 'false');
    }
  }

  function clamp(value, max) { return Math.max(0, Math.min(max, value)); }

  /* ---------- autoplay ---------- */
  function autoplay(root, delay, advance) {
    if (!delay) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (root.getAttribute('data-broek-autoplay') === '1') return;
    root.setAttribute('data-broek-autoplay', '1');

    var timer = null;
    var holdTimer = null;
    var held = false;
    var hovered = false;
    var onScreen = true;

    function tick() {
      if (held || hovered || document.hidden || !onScreen) return;
      advance();
    }
    function start() { if (!timer) timer = setInterval(tick, delay); }
    function stop() { clearInterval(timer); timer = null; }
    function hold() {
      held = true;
      clearTimeout(holdTimer);
      holdTimer = setTimeout(function () { held = false; }, 6000);
    }

    root.addEventListener('mouseenter', function () { hovered = true; });
    root.addEventListener('mouseleave', function () { hovered = false; });
    root.addEventListener('focusin', hold);
    root.addEventListener('pointerdown', hold);
    root.addEventListener('touchstart', hold, { passive: true });
    root.addEventListener('wheel', hold, { passive: true });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
      }, { threshold: 0.2 }).observe(root);
    }

    start();
  }

  /* ---------- scroll-driven track (BROEK style edit) ---------- */
  function scrollTrack(root, track) {
    var state = { pages: 1, max: 0, nav: null };

    function sync() {
      if (!state.nav || state.max <= 0) return;
      var ratio = track.scrollLeft / state.max;
      mark(state.nav, clamp(Math.round(ratio * (state.pages - 1)), state.pages - 1));
    }

    function refresh() {
      state.max = track.scrollWidth - track.clientWidth;
      state.pages = track.clientWidth ? Math.ceil((track.scrollWidth - 2) / track.clientWidth) : 1;
      if (state.pages < 2 || state.max <= 0) { state.nav = null; dropNav(root); return; }
      state.nav = ensureNav(root, state.pages, function (index) {
        track.scrollTo({ left: (index / (state.pages - 1)) * state.max, behavior: 'smooth' });
      });
      root.classList.add('broek-has-dots');
      sync();
    }

    if (wired.indexOf(track) === -1) {
      wired.push(track);
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        raf(function () { ticking = false; sync(); });
      }, { passive: true });
    }

    refresh();
    return refresh;
  }

  function initEdits() {
    var roots = document.querySelectorAll('.broek-edit');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].getAttribute('data-broek-dots') === '1') continue;
      var track = roots[i].querySelector('.broek-edit__track');
      if (!track) continue;
      roots[i].setAttribute('data-broek-dots', '1');
      refreshers.push(scrollTrack(roots[i], track));
    }
  }

  /* ---------- Judge.me cards carousel: no dots, advances on its own ---------- */
  function jdgmTrack(root) {
    var nodes = root.querySelectorAll('.jdgm-cards-wrapper, .jdgm-carousel__item-container, .jdgm-cards-container, .jdgm-videos-container');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].scrollWidth > nodes[i].clientWidth + 4) return { el: nodes[i], scrolls: true };
    }
    return nodes.length ? { el: nodes[0], scrolls: false } : null;
  }

  function translateX(el) {
    var value = window.getComputedStyle(el).transform;
    if (!value || value === 'none') return 0;
    var match = value.match(/matrix3?d?\((.+)\)/);
    if (!match) return 0;
    var parts = match[1].split(',');
    var x = parts.length === 16 ? parseFloat(parts[12]) : parseFloat(parts[4]);
    return isFinite(x) ? x : 0;
  }

  function jdgmCarousel(root) {
    var track = jdgmTrack(root);
    var cards = root.querySelectorAll('.jdgm-card, .jdgm-carousel-item');
    if (!track || cards.length < 2) return null;

    var arrows = root.querySelectorAll('.jdgm-arrow, .jdgm-carousel-arrow');
    var state = { pages: 1, span: 0, index: 0, nav: null };

    function sync() {
      if (!state.span) return;
      var max = track.el.scrollWidth - track.el.clientWidth;
      var next = track.scrolls
        ? (max > 0 ? Math.round((track.el.scrollLeft / max) * (state.pages - 1)) : 0)
        : Math.round(-translateX(track.el) / state.span);
      if (!isFinite(next)) return;
      state.index = clamp(next, state.pages - 1);
      mark(state.nav, state.index);
    }

    function go(index) {
      index = clamp(index, state.pages - 1);
      if (track.scrolls) {
        var max = track.el.scrollWidth - track.el.clientWidth;
        track.el.scrollTo({ left: (index / (state.pages - 1)) * max, behavior: 'smooth' });
      } else if (arrows.length >= 2) {
        var delta = index - state.index;
        var button = delta > 0 ? arrows[arrows.length - 1] : arrows[0];
        for (var i = 0; i < Math.abs(delta); i++) button.click();
      } else {
        return;
      }
      state.index = index;
      mark(state.nav, index);
    }

    function refresh() {
      var width = cards[0].getBoundingClientRect().width;
      var viewport = track.el.clientWidth || root.clientWidth;
      if (!width || !viewport) { dropNav(root); return; }
      var visible = Math.max(1, Math.round(viewport / width));
      state.span = width * visible;
      state.pages = Math.ceil(cards.length / visible);
      if (state.pages < 2) { dropNav(root); return; }
      root.classList.add('broek-has-dots');
      sync();
      autoplay(root, 3000, function () { go((state.index + 1) % state.pages); });
    }

    if (wired.indexOf(track.el) === -1) {
      wired.push(track.el);
      if (track.scrolls) {
        track.el.addEventListener('scroll', function () { raf(sync); }, { passive: true });
      } else if (window.MutationObserver) {
        new MutationObserver(function () { raf(sync); }).observe(track.el, { attributes: true, attributeFilter: ['style', 'class'] });
      }
      track.el.addEventListener('transitionend', sync);
    }

    refresh();
    return refresh;
  }

  function initReviews() {
    var roots = document.querySelectorAll('.jdgm-cards-carousel');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].getAttribute('data-broek-dots') === '1') continue;
      var refresh = jdgmCarousel(roots[i]);
      if (!refresh) continue;
      roots[i].setAttribute('data-broek-dots', '1');
      refreshers.push(refresh);
    }
  }

  function run() { initEdits(); initReviews(); }

  function refreshAll() {
    for (var i = 0; i < refreshers.length; i++) refreshers[i]();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(refreshAll, 200);
  });
  document.addEventListener('shopify:section:load', function () { setTimeout(run, 60); });

  run();
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);

  var tries = 0;
  var poll = setInterval(function () {
    tries++;
    run();
    if (tries > 20) clearInterval(poll);
  }, 700);
})();
